import React from 'react';
import { AccountTree, AltRoute } from '@mui/icons-material';
import {
  Collapse,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { LegalDependencyOverview } from '../LegalTransaction/LegalPhase/LegalDependencyOverview';
import { ProcessManagerTrackingOverview } from './ProcessManagerTrackingOverview';

enum TRACKING_VIEW {
  DEPENDENCIES = 'dependencies',
  TRACKINGS = 'trackings',
}

export const TrackingSectionMain: React.FC = () => {
  const { currentView } = useParams();
  const navigate = useNavigate();

  const view =
    currentView === TRACKING_VIEW.DEPENDENCIES
      ? TRACKING_VIEW.DEPENDENCIES
      : TRACKING_VIEW.TRACKINGS;

  return (
    <Grid container spacing={2}>
      <Grid item xs={2}>
        <List>
          <ListItemButton
            selected={view === TRACKING_VIEW.TRACKINGS}
            onClick={() => navigate(`/tracking/${TRACKING_VIEW.TRACKINGS}`)}
          >
            <ListItemIcon>
              <AltRoute />
            </ListItemIcon>
            <ListItemText primary='Nachverfolgungen' />
          </ListItemButton>

          <ListItemButton
            selected={view === TRACKING_VIEW.DEPENDENCIES}
            onClick={() => navigate(`/tracking/${TRACKING_VIEW.DEPENDENCIES}`)}
          >
            <ListItemIcon>
              <AccountTree />
            </ListItemIcon>
            <ListItemText primary='Abhängigkeiten' />
          </ListItemButton>
        </List>
      </Grid>

      <Grid item xs={10}>
        <Collapse in={view === TRACKING_VIEW.TRACKINGS}>
          <ProcessManagerTrackingOverview />
        </Collapse>

        <Collapse in={view === TRACKING_VIEW.DEPENDENCIES}>
          <LegalDependencyOverview />
        </Collapse>
      </Grid>
    </Grid>
  );
};
